module.exports = __webpack_public_path__ + "static/media/pap2.d57ca581.jpg";